var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"modal"},[_c('h1',{staticClass:"header-title"},[_vm._v(" No access ")]),_c('p',[_vm._v("The CRS dashboard has now closed.")])])])
}]

export { render, staticRenderFns }